import React, { useEffect, useState } from "react";
import {
  Avatar,
  TextField,
  Button,
  Typography,
  InputAdornment,
  IconButton,
  Divider,
} from "@mui/material";
import LockPersonIcon from "@mui/icons-material/LockPerson";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { login } from "../../redux/actions/auth.actions";
import { motion } from "framer-motion";
import EmailIcon from "@mui/icons-material/Email";
import { toast } from "react-hot-toast";
import './login.scss';
import WelcomeComp from "./Welcome";

const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [welcome, setWelcome] = useState(true);

  const { email, password } = formData;
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.authReducer.isAuthenticated);


  useEffect(() => {
    setTimeout(() => {
      setWelcome(false);
    }, 2000);
  }, []);


  if (isAuthenticated) return <Navigate to="/" />;

  const handleClickShowPassword = () => setShowPassword((prev) => !prev);
  const handleMouseDownPassword = (event) => event.preventDefault();
  const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    const resp = await dispatch(login(email, password));
    if (resp?.type === "LOGIN_FAIL") {
      toast.error(resp.msg || "Something went wrong");
    }
  };



  return (
    <>
      {
        welcome ? <WelcomeComp /> :
          <>
            <div className="login login-screen">
              <div className="login-noise-overlay" />
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className={`login-card ${isHovered ? "login-card-hovered" : ""
                  }`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <div className="login-header">
                  <span className="login-chip">Secure Access</span>
                  <motion.div
                    initial={{ scale: 0.8 }}
                    animate={{ scale: 1 }}
                    transition={{ type: "spring", stiffness: 300, damping: 10 }}
                  >
                    <Avatar className="login-avatar">
                      <LockPersonIcon fontSize="medium" />
                    </Avatar>
                  </motion.div>
                  <motion.h2
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2, duration: 0.5 }}
                    className="login-title"
                  >
                    Welcome Back
                  </motion.h2>
                  <Typography variant="body2" className="login-subtitle">
                    Please sign in to continue
                  </Typography>
                </div>

                <Divider className="login-divider" />

                <form onSubmit={onSubmit} className="login-form">
                  <TextField
                    name="email"
                    label="Email"
                    placeholder="Enter email"
                    type="email"
                    value={email}
                    onChange={onChange}
                    fullWidth
                    required
                    variant="outlined"
                    className="login-input"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailIcon color="action" />
                        </InputAdornment>
                      ),
                    }}
                  />

                  <TextField
                    name="password"
                    label="Password"
                    placeholder="Enter password"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={onChange}
                    fullWidth
                    required
                    variant="outlined"
                    className="login-input"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockPersonIcon color="action" />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth
                      className="login-submit-btn"
                    >
                      Sign In
                    </Button>
                  </motion.div>

                  <Typography variant="body2" className="login-footer-text">
                    <span className="login-footer-link">Forgot password?</span>
                    <br />
                    <span className="login-footer-subtext">Please contact your administrator</span>
                  </Typography>
                </form>
              </motion.div>
            </div>
          </>
      }
    </>
  );
};

export default Login;
